import { register } from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('featured-collection', {
  onLoad() {
    const thisSlider = document.querySelector(
      '.featured-collection__content--' + this.id
    );

    if (thisSlider) {
      var slider = new Flickity(thisSlider, {
        freeScroll: false,
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        setGallerySize: true,
        cellAlign: 'left',
        watchCSS: true,
        wrapAround: false,
      });

      Flickity.prototype._createResizeClass = function() {
        this.element.classList.add('flickity-resize');
      };

      Flickity.createMethods.push('_createResizeClass');

      var resize = Flickity.prototype.resize;
      Flickity.prototype.resize = function() {
        this.element.classList.remove('flickity-resize');
        resize.call(this);
        this.element.classList.add('flickity-resize');
      };
    }
  },
});
